import React from 'react';

interface IconActionButtonProps {
  onClick: () => void;
  icon: React.ReactNode;
  title: string;
  id?: string;
  height?: string;
  width?: string;
  className?: string;
  style?: React.CSSProperties;
  btnClass?: string;
}

const IconActionButton: React.FC<IconActionButtonProps> = ({
  onClick,
  icon,
  title,
  id = '',
  height = '32px',
  width = '32px',
  className = '',
  style = {},
  btnClass = 'btn-outline-success',
}) => {
  return (
    <div
      onClick={onClick}
      role="button"
      title={title}
      id={id}
      className={`align-items-flex-start btn ${btnClass} p-1 ${className}`}
      style={{
        display: 'flex',
        cursor: 'pointer',
        padding: '0',
        width: width,
        height: height,
        ...style,
      }}
    >
      {icon}
    </div>
  );
};

export default IconActionButton;
